import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";
import { toast } from "react-toastify";

function* getUserData() {
  try {
    yield put(actions.setUserAction(true));
    const result = yield call(api.getUserData);
    yield put(actions.getUserDataSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
  } finally {
    yield put(actions.setUserAction(false));
  }
}

function* getNotification({ payload }) {
  console.log(payload);
  try {
    yield put(actions.setUserAction(true));
    const result = yield call(api.getNotifications, payload);
    yield put(actions.getNotificationsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    if (response.status === 401) {
      toast.error("Your session has expired. Please login again.");
      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);
      return;
    }
  } finally {
    yield put(actions.getNotificationsFail(false));
  }
}

function* getUserGroups({ payload }) {
  try {
    const result = yield call(api.getUserGroups, payload);
    yield put(actions.getUserGroupsSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
  } finally {
    yield put(actions.getUserGroupsFail(false));
  }
}
export default function* userSaga() {
  yield takeLatest(Types.GET_USER_DATA_REQUEST, getUserData);
  yield takeLatest(Types.GET_USER_GROUPS_REQUEST, getUserGroups);
  yield takeLatest(Types.GET_NOTIFICATIONS_REQUEST, getNotification);
}
